import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

/** 컨베이어 트랙 */
const ITEM_SIZE_PX = 92
const ITEM_GAP_PX = 28
const ITEM_COUNT = 6
const ONE_SET_PX = ITEM_COUNT * (ITEM_SIZE_PX + ITEM_GAP_PX)
const CONVEYOR_DURATION_S = 12
const FLOAT_DISTANCE_PX = 6
const FLOAT_DURATION_S = 3

/** 전환 시퀀스 딜레이 (초) */
const DELAY_FLASH = 0.2
const DELAY_SCREEN_IN = 0.5
const DELAY_TITLE = 0.7
const DELAY_MAG = 0.8
const DELAY_LOOP = 1.3

/** === 전환 keyframes === */

const flashPulse = keyframes`
  0%   { opacity: 0; }
  30%  { opacity: 1; }
  60%  { opacity: 1; }
  100% { opacity: 0; }
`

const searchScreenZoomIn = keyframes`
  0%   { opacity: 0; }
  100% { opacity: 1; }
`

const titleSlideUp = keyframes`
  0%   { opacity: 0; transform: translateY(40px); }
  100% { opacity: 1; transform: translateY(0); }
`

const magIn = keyframes`
  0%   { opacity: 0; transform: scale(0) rotate(-45deg); }
  50%  { opacity: 1; transform: scale(1.15) rotate(8deg); }
  70%  { transform: scale(0.92) rotate(-3deg); }
  100% { opacity: 1; transform: scale(1) rotate(0); }
`

/** === 루프 keyframes === */

const scroll = keyframes`
  from { transform: translateX(-${ONE_SET_PX}px); }
  to { transform: translateX(0); }
`

const float = keyframes`
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(0, -${FLOAT_DISTANCE_PX}px); }
`

/** === Styled Components === */

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: linear-gradient(90deg, #f8fdeb 0%, #ebfcf4 24%, #eef9fe 68%, #faf4ff 100%);
  opacity: 0;
  animation: ${searchScreenZoomIn} 0.5s ${DELAY_SCREEN_IN}s ease-out forwards;
`

export const FlashLayer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 11;
  background: #fff;
  opacity: 0;
  pointer-events: none;
  animation: ${flashPulse} 0.7s ${DELAY_FLASH}s ease-out forwards;
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
`

export const TitleImage = styled.img`
  width: 200px;
  height: auto;
  opacity: 0;
  animation: ${titleSlideUp} 0.45s ${DELAY_TITLE}s ease-out forwards;
`

export const PlmingArea = styled.div`
  position: relative;
  margin-top: 32px;
  animation: ${float} ${FLOAT_DURATION_S}s ease-in-out ${DELAY_LOOP}s infinite;
`

export const PlmingImage = styled.img`
  display: block;
`

export const LensePositioner = styled.div`
  position: absolute;
  top: -2%;
  right: -52%;
  opacity: 0;
  transform: scale(0) rotate(-30deg);
  animation: ${magIn} 0.55s ${DELAY_MAG}s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
`

export const ConveyorSection = styled.div`
  margin-top: 80px;
`

export const ConveyorWrapper = styled.div`
  overflow: hidden;
`

export const ConveyorTrack = styled.div`
  display: flex;
  align-items: center;
  gap: ${ITEM_GAP_PX}px;
  width: max-content;
  will-change: transform;
  backface-visibility: hidden;
  animation: ${scroll} ${CONVEYOR_DURATION_S}s linear infinite;

  img {
    transform: translateZ(0);
    width: ${ITEM_SIZE_PX}px;
    height: 84px;
    object-fit: contain;
    flex-shrink: 0;
  }
`

export const BeltBackground = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-top: -35px;
`

export const BottomFill = styled.div`
  width: 100%;
  height: 96px;
  background-color: #4b4b57;
  flex-shrink: 0;
`
